<template>
  <div class="vendor">
    <img src="@/assets/images/vendor_bg.png" alt="" class="bg img-fluid" />
    <div class="container">
      <vendor-list
        :list="vendorList"
        :isShowPagination="true"
        :hasNext="hasNext"
        :hasLast="hasLast"
        @next="next"
        @last="last"
      ></vendor-list>
    </div>
  </div>
</template>

<script>
import VendorList from '@/components/VendorList';
import { mapMutations } from 'vuex';
import ApiService from '@/common/api.service';
import qs from 'qs';
export default {
  components: {
    VendorList
  },
  computed: {
    hasNext() {
      return (
        this.count > (this.pageNo - 1) * this.pageSize + this.vendorList.length
      );
    },
    hasLast() {
      return this.pageNo > 1;
    }
  },
  data() {
    return {
      vendorList: [],
      pageNo: 1,
      count: 0,
      pageSize: 10
    };
  },
  created() {
    this.setAuth(false);
    this.getAll();
  },
  ...mapMutations(['setAuth']),
  methods: {
    getAll() {
      ApiService.post(
        '/supplierInterface/serachSupplier.htm',
        qs.stringify({
          pageNo: this.pageNo,
          pageSize: this.pageSize
        })
      ).then(data => {
        this.count = data.count;
        this.vendorList = data.list;
        console.log(this.count);
        console.log(this.vendorList);
      });
    },
    next() {
      this.pageNo++;
      this.getAll();
      this.toTop();
    },
    last() {
      if (this.pageNo == 1) {
        return;
      }
      this.pageNo--;
      this.getAll();
      this.toTop();
    },
    toTop() {
      document.body.scrollTop = 0; // For Safari
      document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
    },
    ...mapMutations(['setAuth'])
  }
};
</script>

<style lang="scss" scoped>
.vendor {
  .bg {
    margin-bottom: 2.75rem;
  }
}
</style>
